import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

// Context
import AppContext from "./AppContext";

// Css
import "./App.css";

// Components
import Nav from "./Nav";
import Edit from "./Edit";
import Feed from "./Feed";
import NotFound from "./NotFound";
import UnderMaintenance from "./UnderMaintenance";
import NotMobile from "./NotMobile";
// import Tutorial from "./Tutorial";

function App() {
  const [appContext, setAppContext] = useState({
    foreColor: "#000000",
    foreColorState: true,
    toolBarOn: true,
    hasContent: false,
    textFocus: false,
  });

  return (
    <div className="app">
      <AppContext.Provider value={{ appContext, setAppContext }}>
        <Router>
          {/* <UnderMaintenance /> */}
          {/* <NotMobile /> */}
          {/* <Tutorial /> */}
          <Nav />
          <Switch>
            <Route path="/" exact>
              <Redirect to="/edit" />
            </Route>
            <Route path="/edit" exact component={Edit} />
            <Route path="/feed" component={Feed} />
            <Route component={NotFound} />
          </Switch>
        </Router>
      </AppContext.Provider>
    </div>
  );
}

export default App;
